/* global Backbone */
import Base from 'app/views/base';

import tmpl from 'templates/account_nav';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click a': 'route',
  },

  initialize(options) {
    this.user = options.user;
    this.currentPage = options.currentPage;
  },

  route(e) {
    e.preventDefault();
    Backbone.history.navigate($(e.target).attr('href'), true);
  },

  context() {
    return { filteredNavItems: this.filterACLItems() };
  },

  filterACLItems() {
    const userAcl = this.user.get('acl') || {};
    return this.collection.filter((model) => {
      const navItemAclField = model.get('aclField');
      return !navItemAclField || userAcl[navItemAclField] === true;
    });
  },

  afterRender() {
    const selector = `li[data-page^="${this.currentPage.split('/')[0]}"]`;
    this.$(selector).addClass('active');
    this.$el.parents('.navbar-collapse').removeClass('in');
  },
});



// WEBPACK FOOTER //
// ./app/views/account_nav_view.js